export default "__VITE_ASSET__00808def__"